import styles from "./unlockedAnswerImage.module.scss";
import { Dialog } from "@kunduz/ui-molecules";
import { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { prepareImageUrl } from "./common";

export const AnswerImageModal = (props: Props) => {
  return (
    <Dialog opened={props.visible} close={props.onClose} closeOnClickOutside>
      <div className={styles["answerImageModal"]}>
        <img
          src={prepareImageUrl(props.question.raw_answer_image, 1024)}
          alt={props.question.content}
        />
      </div>
    </Dialog>
  );
};

interface Props {
  visible: boolean;
  onClose: () => void;
  question: QuestionIndexing.TrQiQuestion;
}
